import { useEffect } from 'react';
import { View, ActivityIndicator, StyleSheet } from 'react-native';
import { useRouter } from 'expo-router';
import { Colors } from '../constants/theme';

// =========================================================================
// kyc-subscription — DEPRECADO
// -------------------------------------------------------------------------
// Antes esta pantalla era el último paso del KYC del chofer y forzaba
// entrar tarjeta inmediatamente. Tenía 5 bugs:
//   1) Inputs sin auto-formato (número de tarjeta y MM/AA).
//   2) Decía "30 días de prueba" cuando lo correcto son 15.
//   3) No tenía botón de submit (el handleSubscribe quedaba sin disparador).
//   4) No tenía opción de recarga por transferencia a la billetera.
//   5) El back button quedaba oculto bajo el teclado en algunos devices.
//
// Además forzaba al user a configurar Stripe ANTES de empezar el trial,
// rompiendo la lógica de "manejas gratis 15 días". La pantalla correcta
// que SÍ tiene Stripe real + 15 días + recarga billetera es
// `/driver-subscription`, que el chofer alcanza desde Perfil → Mi
// Suscripción cuando quiera (sin obligación durante el trial).
//
// Esta pantalla queda como un STUB que redirige automáticamente al
// destino correcto, por si algún deep-link o back-navigation accidental
// la abre. Mantener el archivo (en vez de borrarlo) evita "Route not
// found" en expo-router si alguna referencia interna sobrevive.
// =========================================================================

export default function KycSubscriptionRedirect() {
  const router = useRouter();

  useEffect(() => {
    // Usamos replace para que la entrada de history no quede registrada —
    // si el user toca atrás desde driver-subscription no debe volver acá.
    router.replace('/driver-subscription' as any);
  }, [router]);

  return (
    <View style={styles.center}>
      <ActivityIndicator size="large" color={Colors.primary} />
    </View>
  );
}

const styles = StyleSheet.create({
  center: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.background,
  },
});
